import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';

export const InformModal = ({ isOpen, text, confirmCallback, title = '' }) => {
    const _handleConfirm = () => {
        confirmCallback();
    };

    return (
        <div>
            <Dialog
                open={isOpen}
                // onClose={_handleCancel}
                aria-labelledby='alert-dialog-title'
                aria-describedby='alert-dialog-description'
            >
                {title && (
                    <div
                        className='page-header'
                        role='banner'
                    >
                        <h1 style={{ height: '50px', marginTop: '15px' }}>{title}</h1>
                    </div>
                )}
                <DialogContent>
                    <DialogContentText>
                        <div dangerouslySetInnerHTML={{ __html: text }}></div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <div className='row'>
                        <button
                            type='button'
                            className='button primary'
                            onClick={_handleConfirm}
                        >
                            Close
                        </button>
                    </div>
                </DialogActions>
            </Dialog>
        </div>
    );
};
